// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rpBtn[data-v-1ce187a6]{background:var(--bg)!important;color:var(--color)!important}", ""]);
// Exports
module.exports = exports;
